var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"module-white"},[_c('div',{staticClass:"mod-shop-white",style:({height: _vm.content.height + 'px', backgroundColor: _vm.render(_vm.content)})})])
}
var staticRenderFns = []

export { render, staticRenderFns }